import { getFAQPageSchema, IFAQSchema } from '@domain/seo/schema';
import { JsonLd } from '../../../JsonLd/JsonLd';

export const FAQSchema = ({ faqMetaData }: { faqMetaData: IFAQSchema[] }) => {
  return <JsonLd schema={getFAQPageSchema(faqMetaData)} />;
};
